import { Grid, Paper } from "@material-ui/core";
import TextInputField from "components/Admin/InputFields/TextInputField";
import {
  BorderLinearProgress,
  FIELDS,
  ProgressBar,
} from "components/Admin/InputFields/utils";
import { selectAllAccessories } from "features/admin/Accessories/accessoriesAdminSlice";
import { StyledSubmitButton } from "features/admin/Gallery/components/AddGalleryItem";
import { selectProductsIds } from "features/admin/Products/productsAdminSlice";
import { useStyles } from "features/admin/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MdSave } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components/macro";
import ProductTabs from "../components/ProductTabs";
import {
  selectEditOrder,
  fetchOrderForEdit,
  setEditOrder,
  setOrderElements,
  updateOrder,
} from "../ordersAdminSlice";
import { AddOrderForm, HiddenInput } from "./AddOrder";

interface EditOrderProps {}

const EditOrder: React.FC<EditOrderProps> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const { handleSubmit, control, errors, setValue, getValues } = useForm();

  const { id } = useParams();
  const classes = useStyles();

  const editFields = useSelector(selectEditOrder);
  useEffect(() => {
    dispatch(fetchOrderForEdit(id));

    return () => {
      dispatch(setEditOrder(undefined));
      dispatch(setOrderElements([]));
    };
  }, []);

  const renderField = (field: any, idx: number) => {
    if (field.items) {
      return <></>;
    }

    const Field = FIELDS[field.type];
    return (
      <Field item={field} key={idx} control={control} setValue={setValue} />
    );
  };

  const onSubmit = (data: any) => {
    dispatch(
      updateOrder(data, id, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return editFields ? (
    <div>
      <Paper className={classes.paper}>
        <Grid container direction="row" wrap="wrap" align-items="center">
          <AddOrderForm
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
          >
            {editFields.map((item: any, idx: any) => {
              return renderField(item, idx);
            })}
            <HiddenInput>
              <TextInputField
                item={{
                  required: true,
                  type: "text",
                  title: "Добавени климатици",
                  name: "items",
                  rules: {
                    required: { value: true, message: "Полето е задължително" },
                  },
                }}
                control={control}
                reset={false}
                setValue={setValue}
                errors={errors}
              />
            </HiddenInput>
            <ProductTabs
              getValues={getValues}
              setValue={setValue}
              activeValues={editFields.find((item: any) => {
                const keys = Object.keys(item);
                return keys.includes("items");
              })}
            />
            <ProgressBar>
              <BorderLinearProgress variant="determinate" value={progress} />
            </ProgressBar>
            <StyledSubmitButton
              variant="contained"
              color="primary"
              type="submit"
              startIcon={<MdSave size="1.5rem" />}
            >
              Промени поръчка
            </StyledSubmitButton>
          </AddOrderForm>
        </Grid>
      </Paper>
    </div>
  ) : (
    <></>
  );
};

export default EditOrder;
